import { errorMessageHandler, http } from "../api.services";

export const getAgentTaskDetails = async (roleid: string) => {
  try {
    const url = `${process.env.VITE_AWS_AGENT_TASK_DETAILS_API_URL}?roleid=${roleid}`;

    // url.searchParams.append("roleid", roleid);

    const data = await http
      .get(url.toString(), {
        headers: {
          // "x-api-key": process.env.VITE_BASE_API_KEY,
        },
        cache: "no-cache",
      })
      .json();
    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getAgentTaskDetailsById = async (
  taskId: any,
  roleid: string,
  extractionVersion: any = "lastversion"
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_AWS_AGENT_TASK_DETAILS_API_URL}/${taskId}`
    // );
    const finalRoleId = localStorage.getItem("roleid");
    console.log(
      "Checking Role Id for evry TaskDetails API call",
      finalRoleId,
      roleid
    );
    // url.searchParams.append(
    //   "roleid",
    //   finalRoleId !== null ? finalRoleId : roleid
    // );
    // Append the extractionVersion query parameter, defaulting to "lastversion"
    // url.searchParams.append("extractionVersion", extractionVersion);

    const data = await http
      .get(
        `${process.env.VITE_AWS_AGENT_TASK_DETAILS_API_URL}/${taskId}?roleid=${finalRoleId !== null ? finalRoleId : roleid}&extractionVersion=${extractionVersion}`,
        {
          headers: {
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const putAgentTaskDetails = async (
  taskId: number,
  roleid: string,
  body: any
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_AWS_AGENT_SAVE_TASK_API_URL}/${taskId}`
    // );

    // url.searchParams.append("roleid", roleid);
    const data = await http
      .put(
        `${process.env.VITE_AWS_AGENT_SAVE_TASK_API_URL}/${taskId}?roleid=${roleid}`,
        {
          json: { ...body },
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const agentRaiseException = async (
  taskId: number,
  roleid: string,
  body: any
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_RAISE_EXCEPTION_API_URL!.replace(
    //     "{taskid}",
    //     taskId.toString()
    //   )}`
    // );

    // url.searchParams.append("roleid", roleid);

    const data = await http
      .put(
        `${process.env.VITE_RAISE_EXCEPTION_API_URL!.replace("{taskid}", taskId.toString())}?roleid=${roleid}`,
        {
          json: { ...body },
          headers: {
            "Content-Type": "application/json",
            // "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
//VITE_SEND_RESPOND_API_URL

export const SMEsendRespond = async (
  taskId: number,
  roleid: string,
  body: any
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_SEND_RESPOND_API_URL!.replace(
    //     "{taskid}",
    //     taskId.toString()
    //   )}`
    // );

    // url.searchParams.append("roleid", roleid);

    const data = await http
      .put(
        `${process.env.VITE_SEND_RESPOND_API_URL!.replace(
          "{taskid}",
          taskId.toString()
        )}?roleid=${roleid}`,
        {
          json: { ...body },
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const agentSaveAndConfirm = async (
  taskId: number,
  roleid: string,
  body: any
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_CONFIRM_AND_SUBMIT_API!.replace(
    //     "{taskid}",
    //     taskId.toString()
    //   )}`
    // );

    // url.searchParams.append("roleid", roleid);

    const data = await http
      .put(
        `${process.env.VITE_CONFIRM_AND_SUBMIT_API!.replace(
          "{taskid}",
          taskId.toString()
        )}?roleid=${roleid}`,
        {
          json: { ...body },
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const postReferenceData = async <T>(body: object) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_POST_REFERENCE_DATA_URL!, {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const agentKeyedOn = async (taskId: any, roleid: string) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_AWS_PUT_KEYED_ON_URL!.replace(
    //     "{taskid}",
    //     taskId.toString()
    //   )}`
    // );
    // url.searchParams.append("roleid", roleid);
    const data = await http
      .put(
        `${process.env.VITE_AWS_PUT_KEYED_ON_URL!.replace(
          "{taskid}",
          taskId.toString()
        )}?roleid=${roleid}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const WNSSMEHoldReasonResponse = async (
  taskId: number,
  roleid: string,
  body: any
) => {
  try {
    // const url = new URL(
    //   `${process.env.VITE_SEND_HOLD_REASON_RESPONSE_API_URL!.replace(
    //     "{taskid}",
    //     taskId.toString()
    //   )}`
    // );
    // url.searchParams.append("roleid", roleid);
    const data = await http
      .put(
        `${process.env.VITE_SEND_HOLD_REASON_RESPONSE_API_URL!.replace(
          "{taskid}",
          taskId.toString()
        )}?roleid=${roleid}`.toString(),
        {
          json: { ...body },
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VITE_BASE_API_KEY,
          },
          cache: "no-cache",
        }
      )
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
